/**
 * Type guard to check if metadata object has a url property
 */
export const isMetadataWithUrl = (
  metadata: unknown
): metadata is { url: string } => {
  return (
    typeof metadata === "object" &&
    metadata !== null &&
    "url" in metadata &&
    typeof (metadata as Record<string, unknown>).url === "string"
  );
};
